import { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';


export default function Ege() {
  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)

  const { values, setValues } = allForms

  const { exams: examsData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  useEffect(() => {
    const dataJson = JSON.stringify(examsData)
    if (!addMode && examsData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({ ...prev, exams: [...examsData] }))
      if (updateInitialValues) updateInitialValues('exams', examsData)
    }
  }, [examsData, addMode, setValues, updateInitialValues])

  const renderLi = (item, idx) => (
    <tr key={item.id || idx}>
      <td>{item.exam_type || ''}</td>
      <td>{item.ppe || ''}</td>
      <td>{item.codeou || ''}</td>
      <td>{item.edate || ''}</td>
      <td>{item.course_name || ''}</td>
      <td style={{ textAlign: 'center' }}>{item.firstpoints || ''}</td>
      <td style={{ textAlign: 'center' }}>{item.points || ''}</td>
      <td style={{ textAlign: 'center' }}>{item.grade || ''}</td>
      <td style={{ textAlign: 'center' }}>{item.result ? 'Да' : 'Нет'}</td>
    </tr>
  )

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Вид экзамена</th>
              <th>ППЭ</th>
              <th>Код ОУ</th>
              <th>Дата сдачи</th>
              <th>Предмет</th>
              <th style={{ textAlign: 'center' }}>Первичный балл</th>
              <th style={{ textAlign: 'center' }}>Балл</th>
              <th style={{ textAlign: 'center' }}>Оценка</th>
              <th style={{ textAlign: 'center' }}>Результат</th>
            </tr>
          </thead>
          <tbody>
            {(values.exams || []).map(renderLi)}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
